module.exports = __webpack_public_path__ + "img/hk_room-background.37d2a1b5.png";